


































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import dokument from '@/store/modules/dokument';
import { CashflowAnalysisGroup, ListSection } from '@/store/models';

@Component({ components: {} })
export default class CashflowAnalysis extends Vue {
  @Prop() readonly group!: CashflowAnalysisGroup;

  selectedTable: any = {};
  selectedRecommendation: any = {};

  @Watch('group', { immediate: true, deep: true })
  onData() {
    if (this.group.Table === 'none') {
      this.selectedTable = this.tableItems[0];
    } else {
      this.selectedTable = this.tableItems[1];
    }

    switch (this.recommendation) {
      case 'cashflowRecommendation_financing':
        this.selectedRecommendation = this.recomendationItems[4];
        break;
      case 'cashflowRecommendation_investments':
        this.selectedRecommendation = this.recomendationItems[3];
        break;
      case 'cashflowRecommendation_workingcapital':
        this.selectedRecommendation = this.recomendationItems[2];
        break;
      case 'cashflowRecommendation_daytoday':
        this.selectedRecommendation = this.recomendationItems[1];
        break;
      default:
        this.selectedRecommendation = this.recomendationItems[0];
    }

    this.update();
  }

  @Watch('selectedTable', { immediate: false, deep: true })
  selectedTableChanged() {
    this.update();
  }

  @Watch('selectedRecommendation', { immediate: false, deep: true })
  selectedRecommendationChanged() {
    this.update();
  }

  update() {
    if (
      this.group.Table === this.selectedTable.id &&
      this.group.Recommendation === this.selectedRecommendation.id
    ) {
      return;
    }

    let children: any[];
    if (
      this.selectedTable.id === 'none' &&
      this.selectedRecommendation.id === 'cashflowRecommendation_none'
    ) {
      children = [2001, 2008, 2002, 2003, 2004];
    } else if (this.selectedTable.id === 'none') {
      children = [2001, 2008, 2002, 2003, 2004, 2006, 2007];
    } else if (
      this.selectedRecommendation.id === 'cashflowRecommendation_none'
    ) {
      children = [2001, 2008, 2002, 2003, 2004, 2005];
    } else {
      children = [2001, 2008, 2002, 2003, 2004, 2005, 2006, 2007];
    }

    const g = {
      Id: this.group.Id,
      Kind: this.group.Kind,
      Type: this.group.Type,
      SubType: this.group.SubType,
      Children: children,
      Table: this.selectedTable.id,
      Recommendation: this.selectedRecommendation.id,
      Hidden: this.hidden,
    };
    dokument.updateItem(g);

    const s = {
      Id: this.section.Id,
      Kind: this.section.Kind,
      Type: this.section.Type,
      SubType: this.selectedRecommendation.id,
    };
    dokument.updateItem(s);
  }

  get recommendation() {
    switch (this.group.Recommendation) {
      case 'financing':
        return 'cashflowRecommendation_financing';
      case 'investments':
        return 'cashflowRecommendation_investments';
      case 'workingcapital':
        return 'cashflowRecommendation_workingcapital';
      case 'daytoday':
        return 'cashflowRecommendation_daytoday';
      default:
        return this.section.SubType;
    }
  }

  get hidden(): boolean {
    return (
      this.selectedTable.id === 'none' &&
      this.selectedRecommendation.id === 'cashflowRecommendation_none'
    );
  }

  items() {
    if (!this.section || !this.section.Items) {
      return [];
    }
    return this.section.Items.map((r: any) => {
      return { Value: r.Value, Marked: false };
    });
  }

  get section(): ListSection {
    return dokument.getItem(2007) as ListSection;
  }

  get tableItems() {
    return [
      {
        id: 'none',
        label: 'Ingen kassaflödestabell inkluderas',
      },
      {
        id: 'detailed',
        label: 'Inkludera detaljerad kassaflödestabell',
      },
    ];
  }

  get recomendationItems() {
    return [
      {
        id: 'cashflowRecommendation_none',
        label: 'Ingen rekommendation lämnas',
      },
      {
        id: 'cashflowRecommendation_daytoday',
        label: 'Fokus på operativ verksamhet',
      },
      {
        id: 'cashflowRecommendation_workingcapital',
        label: 'Fokus på bolagets rörelsekapital',
      },
      {
        id: 'cashflowRecommendation_investments',
        label: 'Fokus på bolagets investeringar',
      },
      {
        id: 'cashflowRecommendation_financing',
        label: 'Fokus på bolagets finansiering',
      },
    ];
  }
}
